import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';
import { VeiculoVendidoDetalhadoModule } from '../veiculo-vendido-detalhado/veiculo-vendido-detalhado.module';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { VeiculoVendidoFiltroService } from './veiculo-vendido-filtro.service';
import { VeiculoVendidoComponent } from './veiculo-vendido.component';
import { VeiculoVendidoService } from './veiculo-vendido.service';


@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TreeTableModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    OsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TooltipModule,
    VeiculoVendidoDetalhadoModule
  ],
  exports: [
    VeiculoVendidoComponent
  ],
  declarations: [
    VeiculoVendidoComponent,
  ],
  providers: [
    VeiculoVendidoService,
    VeiculoVendidoFiltroService,
    DatePipe
  ]
})
export class VeiculoVendidoModule { }
